<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>My Stock Register</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">

                        <b>Academic Year</b> <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense required class="mt-4" v-model="ay" item-value="id"
                            :items="ay_list" item-text="ay" label="Academic Year"
                             outlined  @change="getReport()"/>

                    </v-col>
                    <!-- <v-col cols="12" sm="2" md="2" class="mt-10" v-if="ay && ay_list.length > 0">
                        <v-btn class="button" @click="getReport()" :loading="loader">Fetch
                            Report</v-btn>
                    </v-col> -->

                </v-row>

            </v-card>

            <!-- <span v-if="mainList != '' && mainList != null"> -->
            <v-card v-if="getmystockregisterlist.length > 0">
                <v-card-title>
                    <v-btn v-if="getmystockregisterlist != '' && getmystockregisterlist != null"
                        class="ml-2 mt-5 no-display" rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'InvoiceReport')" :loading="loader">
                        <v-icon color="success">mdi-export</v-icon>Export
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="getmystockregisterlist.length > 0" :headers="headers1"
                    :items="getmystockregisterlist" :search="search" class="elevation-1 mytable" id="my-table-id">
                    
                </v-data-table>
            </v-card>
            <!-- </span> -->




            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>




        </v-container>

    </div>

</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
    data: () => ({

        loader: false,
        snackbar_msg: "",
        search: "",
        basepath: null,
        color: "",
        snackbar: false,
        overlay: false,
        ay_list: [],
        getmystockregisterlist: [],


        headers1: [
            {
                text: "Sr. No.",
                value: "srno",
            },
           
            {
                text: "Item Category",
                align: "center",
                value: "item_category",
            },
            {
                text: "Item Name",
                align: "center",
                value: "item_name",
            },
            {
                text: "Size Label Type",
                align: "center",
                value: "size_label_type",
            },
            {
                text: "Size Label",
                align: "center",
                value: "size_label",
            },
            {
                text: "Standard",
                align: "center",
                value: "standard",
            },
            {
                text: "Academic Year",
                align: "center",
                value: "academicyear",
            },
            {
                text: "Transaction Type",
                align: "center",
                value: "transaction_type",
            },
            {
                text: "Transaction Date",
                align: "center",
                value: "transaction_date",
            },
            {
                text: "Quantity",
                align: "center",
                value: "quantity",
            },
            {
                text: "Remark",
                align: "center",
                value: "remark",
            },
           

        ],

    }),
    methods: {

        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },


        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        onLoad() {
            axios
                .post("/EduStore/getStaffStudentAyVendorlist")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.ay_list = res.data.ay_list;
                     } else {ay_list
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        
        getReport() {
            this.loader = true;
            this.getmystockregisterlist = [];
            const data = {

                ay: this.ay
            };
            axios
                .post("/EduStore/fetchMyStockRegister", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.getmystockregisterlist = res.data.my_stock_register_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.msg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}
</style>
